import { render, staticRenderFns } from "./identify-code.vue?vue&type=template&id=cd20e6c6&scoped=true&"
import script from "./identify-code.vue?vue&type=script&lang=js&"
export * from "./identify-code.vue?vue&type=script&lang=js&"
import style0 from "./identify-code.vue?vue&type=style&index=0&id=cd20e6c6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd20e6c6",
  null
  
)

export default component.exports